import React from 'react';

export function LogoMark({ size = 32, color }) {
  const c = color || '#FAF6EF';
  // Conselo-like icon: stylized 'C' with gold dot
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
      <circle cx="20" cy="20" r="18" stroke={c} strokeWidth="1.5" fill="none" />
      <path d="M28 14a10 10 0 1 0 0 12" stroke={c} strokeWidth="2" fill="none" strokeLinecap="round" />
      <circle cx="29" cy="20" r="3" fill="#C6C4CF" />
    </svg>
  );
}

export default function Logo({ color }) {
  const c = color || '#FAF6EF';
  return (
    <div className="flex items-center gap-3" aria-label="ClicksyHub">
      <LogoMark color={c} />
      <span style={{ color: c, fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 26, letterSpacing: '-0.03em' }}>
        Clicksy<span style={{ fontWeight: 400 }}>Hub</span>
      </span>
    </div>
  );
}
